import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import store from './store'

Vue.config.productionTip = false

import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);


new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
